import React from "react";
import {
  Page,
  Document,
  Image,
  StyleSheet,
  Text,
  Font,
  View,
} from "@react-pdf/renderer";
import allfont from "../../../../assets/fonts/ZCOOL_XiaoWei/ZCOOLXiaoWei-Regular.ttf";
import notoSans from "../../../../assets/fonts/NotoSans/NotoSansSC-Regular.ttf";
import default_logo from "assets/images/headerLogo.png";
import blankImage from "assets/images/empty.png";

//Font.register({
//  family: "ZCOOL XiaoWei",
//  src: "https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@300&display=swap",
//  format: "truetype",
//});
Font.register({
  family: "ZCOOL XiaoWei",
  src: allfont,
});
Font.register({
  family: "NotoSans",
  src: notoSans,
});

const borderColor = "#90e5fc";

const NewLineText = (text) => {
  if (text) {
    const newText = text.split(/\n|\\n/).map((str, idx) => (
      <Text
        key={idx}
        style={[
          styles.termsCondtionTitle,
          styles.marginVerticalTop2,

          idx === 0 && styles.marginBottom5,
        ]}
      >
        {str}
      </Text>
    ));

    return newText;
  }
};
const NewLineAddress = (text) => {
  if (text) {
    const newText = text.split(/\n|\\n/).map((str, idx) => (
      <Text
        key={idx}
        style={[
          styles.addressTitle,
          styles.marginVerticalTop2,
          idx === 0 && styles.marginBottom5,
        ]}
      >
        {str}
      </Text>
    ));

    return newText;
  }
};
//const termsText = `Terms and Condition: \n 1: Any free sessions, complimentary service, rewards programme purchased all are non-exchangeable or refundable. \n 2: All service packages are valid for twelve months from the date of purchase. \n 3: Deposits for A La carte service will be for forfeited for cancellation of less than 24hours before the treatment. \n 4: a) Deposit for package service will be forfeited if customer does not come to redeem the booked package after 12 months from the paid date. \n b) Deposits for package : If customer wants to make appointment for next treatment, their payment must paid more than the next treatment course. For any late cancellation or “no-show”, the company has the right to deduct 1 x treatment course from their treatment package (will be treated as the treatment is taken). \n 5: If customer arrived late for appointment,the company has the rights to reduce the session time accordingly or complete the treatment by the appointed time and charge full amount of the booked treatment.(Applicable for A La carte service and package) \n 6: Embrace Beauty Pte Ltd reserves the right to charge all utilized service at ala carte prices upon termination of the package. \n 7: Refund Policy: \n a) If customer do not wish to proceed with the services and made known to the company within the cooling off period of 5 working days (exclude Sat,Sun & Public Holidays),the company will refund 100% of what the customer had paid. The redeemed treatment of the package is strictly non-refundable . Mode of refund will be in cheque. \n b) Prepaid packages AFTER cooling-off period is non-refundable unless the customer provide a medical note. The balanced and un-utilized sessions will be pro-rated based on ala-carte price minus an administrative charges (10%) and refunded in the form of a cheque. The redeemed treatment of the package is strictly non-refundable. \n c) Product exchange is applicable within 5 working days from the date of sale and only if the product is intact and deemed in good condition with the discretion of the management final judgement.\n \n The Company reserves the right to amend the terms and conditions herein and/or the specific terms and conditions at anytime and the customer shall be bound by the amended terms and conditions. Notice of the amendments may be given by the Company to the customer in such a manner, as the Company deem fit and proper.`;
const termsText = ``;

const styles = StyleSheet.create({
  page: {
    padding: 20,
    // minWidth: "300.1mm",
    // maxWidth: "300.1mm",
    fontFamily: "NotoSans",
  },
  section: {
    marginBottom: 22,
  },

  // companyTitle
  companyTitle: {
    fontSize: 15,
    fontWeight: "extrabold",
    // fontWeight: "bold",
    textAlign: "center",
    paddingBottom: 5,
    // fontFamily: "Noto Sans SC",
  },
  rocTitle: {
    fontSize: 12,
    //marginLeft: 5,
    textAlign: "center",
  },

  // headerSection
  headerSection: {
    display: "flex",
    flexDirection: "row",
  },
  headerImgContainer: {
    // marginLeft: "10%",
    width: "25%",
    alignContent: "center",
  },
  headerCompanyContainer: {
    width: "50%",
  },
  headerAddressContainer: {
    width: "25%",
  },
  width100: {
    display: "flex",
  },
  headerLogoWidth: {
    width: 100,
    height: 60,
    objectFit: "contain",
  },

  headerTitle: {
    fontSize: 10,
    marginBottom: 3,
    textAlign: "center",
  },

  borderBottomCommon: {
    borderBottomWidth: 1,
    borderBottomStyle: "dashed",
  },

  marginTopCommon: {
    marginTop: 20,
  },

  // userDataContainer

  flexDirectionCommon: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 5,
  },
  userContentTitle: {
    fontSize: 10,
    fontWeight: "extrabold",
    width: "30%",
  },
  userContentSub: {
    fontSize: 10,
    fontWeight: 500,
  },

  tableHeader: {
    flexDirection: "row",
    textAlign: "center",
    fontSize: 10,
    padding: "10px 0px",
    fontWeight: "bold",
  },
  tableBody: {
    flexDirection: "row",
    textAlign: "center",
    fontSize: "9px",
    marginBottom: 10,
  },
  receipt: {
    textAlign: "left",
    fontSize: 10,
    marginBottom: 10,
  },
  width05: {
    width: "05%",
  },
  width10: {
    width: "10%",
  },
  width20: {
    width: "20%",
    textAlign: "left",
  },
  width25: {
    width: "25%",
  },

  width30: {
    width: "30%",
  },
  width40: {
    width: "40%",
  },
  width50: {
    width: "50%",
  },
  width60: {
    width: "60%",
  },
  width70: {
    width: "70%",
  },
  width75: {
    width: "75%",
  },

  width80: {
    width: "80%",
  },
  paddingTop5: {
    paddingTop: 5,
  },
  marginVerticalTop2: {
    marginVertical: 0.5,
  },
  texalignRight: {
    textAlign: "right",
  },
  marginTop10: {
    marginTop: 5,
  },

  qty: {
    width: "10%",
  },
  description: {
    width: "15%",
  },
  payment: {
    width: "20%",
  },
  subTotal: {
    // textAlign: "right",
    fontSize: 10,
    marginBottom: 10,
  },
  fontWeightBold: {
    fontWeight: "bold",
    color: "black",
  },

  subTotalContainer: {
    flexDirection: "row",
    marginTop: 20,
  },
  subTotalFont: {
    fontSize: 10,
  },
  fontSize9: {
    fontSize: 9,
  },
  subTableContainer: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginTop: 20,
  },
  subTotalParent: {
    display: "flex",
    flexDirection: "row",
    paddingBottom: 5,
  },
  subTotalBorder: {
    borderBottomWidth: 1,
    borderBottomColor: "black",
    borderStyle: "dotted",
  },
  subTotalBorderTop: {
    borderTopWidth: 1,
    borderTopColor: "black",
    borderStyle: "dotted",
  },
  memberInfo: {
    textAlign: "left",
    fontSize: 10,
    marginBottom: 10,
  },

  listContainer: {
    display: "flex",
    flexDirection: "row",
    paddingBottom: 5,
  },
  customerSignatureContainer: {
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
  termsCondtionTitle: {
    color: "#646464",
    fontSize: 7.5,
    textAlign: "justify",
    lineHeight: ".65rem",
  },
  addressTitle: {
    color: "#646464",
    fontSize: 10,
    textAlign: "center",
    lineHeight: ".65rem",
  },
  customerSignWidth: {
    width: "80%",
    height: "50px",
  },
  termsConditonContainer: {
    display: "flex",
    flexDirection: "row",
  },
  marginVertical10: {
    marginVertical: 10,
  },
  marginBottom5: {
    marginBottom: 5,
  },
  prepaidContainer: {
    display: "flex",
    flexDirection: "row",
    width: "50%",
  },
  width60: {
    width: "60%",
  },
  width40: {
    width: "40%",
  },
  titlecontainer: {
    fontSize: 10,
    fontWeight: 500,
    textAlign: "center",
    paddingVertical: 3,
  },
  prepaidBorder: {
    borderTop: 1,
    borderStyle: "dotted",
    marginVertical: 8,
  },
  desTitle: {
    fontSize: 8,
    textAlign: "center",
    lineHeight: 1.5,
  },
  desBalance: {
    fontSize: 8,
    textAlign: "center",
  },
  marginVertical4: {
    padding: 5,
  },
  border1px: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "black",
  },
  borderTopHide: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "black",
    borderTop: 0,
  },
  borderLeft1px: {
    borderLeftWidth: 1,
    borderStyle: "solid",
    borderColor: "black",
  },

  // tableWidth
  tableWidth: {
    flexBasis: 0,
    flexGrow: 1,
    maxWidth: "100%",
  },
  flexWrapContainer: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    marginVertical: 15,
  },
  tableHeading: {
    fontSize: 12,
    fontWeight: "extrabold",
    color: "black",
  },

  descriptionCourse: {
    width: "25%",
  },
  paymentCourse: {
    width: "20%",
  },
});

export class PrintPreview extends React.Component {
  // handleCheckStatus
  handleChangeCheckStatus = (arrayData, name) => {
    const status = arrayData.some(
      (obj) =>
        obj.hasOwnProperty("name") && obj.name === name && obj.checked === true
    );

    return status;
  };

  // handleCheckNameLabel
  handleCheckNameLabel = (arrayData, name) => {
   const matchedObj = arrayData.find(
    (obj) =>
      obj.hasOwnProperty("name") &&
      obj.name === name &&
      obj.checked === true
   );

   return matchedObj ? matchedObj.namelabel : "";
  };
  
  // handleReturnData
  handleReturn = (name, data) => {
    const {
      sa_custno,
      sa_custname,
      nric,
      cust_refer,
      cust_phone2,
      trans,
      sa_date,
      Time,
      issued,
    } = data;

    let returnValue = "";

    switch (name) {
      case "Code":
        returnValue = sa_custno;
        break;
      case "Name":
        returnValue = sa_custname;
        break;
      case "NRIC":
        returnValue = nric;
        break;
      case "Cust Refer":
        returnValue = cust_refer;
        break;
      case "Cust Phone":
        returnValue = cust_phone2;
        break;
      case "Trans":
        returnValue = trans;
        break;
      case "Date":
        returnValue = sa_date;
        break;
      case "Time":
        returnValue = Time;
        break;
      case "Issued":
        returnValue = issued;
        break;
      default:
        break;
    }

    return returnValue;
  };

  // NewLineText = (text) => {
  //   const newText = text.split("\n").map((str) => (
  //     <p className="col-12" style={{ lineHeight: "1.0rem" }}>
  //       {str}
  //     </p>
  //   ));

  //   return newText;
  // };

  render() {
    let {
      accountHeader,
      responseData,
      Flag,
      landscape = false,
      customerSingature = accountHeader?.cust_sig,
      settingList,
      transactionOrderChangeList,
    } = this.props;

    let { headerList, footerList, bodyList } = settingList;

    let {
      hdr_data = [],
      dtl_data = [],
      sub_data = {},
      taud_data = [],
      footer = {},
      company_hdr = {},
      taud_sub = {},
    } = responseData;

    let {
      showprepaid,
      prepaidlst,
      footer1,
      footer2,
      footer3,
      footer4,
      remark,
      treatment = [],
      treatmentbal = false,
    } = footer;

    return (
      <Document file="somefile.pdf">
        <Page style={styles.page}>
          <View style={styles.headerSection}>
            <View style={styles.headerImgContainer}>
              {this.handleChangeCheckStatus(headerList, "Logo") && (
                <Image
                  style={styles.headerLogoWidth}
                  src={accountHeader?.logo ? accountHeader?.logo : default_logo}
                />
              )}
            </View>
            <View style={styles.headerCompanyContainer}>
              {this.handleChangeCheckStatus(headerList, "Company Name") && (
                <Text style={styles.companyTitle}>
                  {accountHeader?.name ? accountHeader?.name : "Beautesoft"}
                  <Text style={styles.rocTitle}>
                    {this.handleChangeCheckStatus(headerList, "ROC") &&
                      company_hdr?.company_reg_no &&
                      `  (ROC No: ${company_hdr?.company_reg_no || "--"})`}
                  </Text>
                </Text>
              )}
              {this.handleChangeCheckStatus(headerList, "Company Address") && (
                <View style={styles.addressTitle}>
                  {NewLineAddress(accountHeader?.address)}
                </View>
              )}
            </View>

            <View style={styles.headerAddressContainer}>
              <View>
                {this.handleChangeCheckStatus(headerList, "Tax Invoice") && (
                  <Text style={styles.headerTitle}>
                    {hdr_data ? hdr_data?.invoice_header : ""}
                  </Text>
                )}
              </View>
            </View>
          </View>

          <View style={styles.borderBottomCommon} />

          <View style={styles.flexWrapContainer}>
            {transactionOrderChangeList.map((item, id) => {
              return (
                <View key={id} style={styles.width50}>
                  {this.handleChangeCheckStatus(bodyList, item.name) && (
                    <View style={styles.flexDirectionCommon}>
                      <Text style={styles.userContentTitle}>{item.name} </Text>
                      <Text style={styles.userContentSub}>
                        :{" "}
                        {hdr_data ? this.handleReturn(item.name, hdr_data) : ""}
                      </Text>
                    </View>
                  )}
                </View>
              );
            })}
          </View>

          <View style={styles.borderBottomCommon} />
          <View style={styles.tableHeader}>
            {this.handleChangeCheckStatus(bodyList, "Table Sno") && (
              <View style={styles.tableWidth}>
                <Text style={styles.tableHeading}>{`No`}</Text>
              </View>
            )}
            {this.handleChangeCheckStatus(bodyList, "Table Desc") && (
              <View style={styles.width20}>
                <Text style={styles.tableHeading}>{`Description`}</Text>
              </View>
            )}
            {this.handleChangeCheckStatus(bodyList, "Table Qty") && (
              <View style={styles.tableWidth}>
                <Text style={styles.tableHeading}>{`Qty`}</Text>
              </View>
            )}
            {this.handleChangeCheckStatus(bodyList, "Table U/P") && (
              <View style={styles.tableWidth}>
                <Text style={styles.tableHeading}>{`U/P`}</Text>
              </View>
            )}
            {this.handleChangeCheckStatus(bodyList, "Table Disc") && (
              <View style={styles.tableWidth}>
                <Text style={styles.tableHeading}>{`Disc.`}</Text>
              </View>
            )}
            {this.handleChangeCheckStatus(bodyList, "N/P") && (
              <View style={styles.tableWidth}>
                <Text style={styles.tableWidth}>{`N/P`}</Text>
              </View>
            )}
            {this.handleChangeCheckStatus(bodyList, "Table Paid") && (
              <View style={styles.tableWidth}>
                <Text style={styles.tableHeading}>{`Paid`}</Text>
              </View>
            )}

            {this.handleChangeCheckStatus(bodyList, "Sold By") && (
              <View style={styles.tableWidth}>
                <Text style={styles.tableHeading}>{`Sold By`}</Text>
              </View>
            )}
            {this.handleChangeCheckStatus(bodyList, "Service By") && (
              <View style={styles.tableWidth}>
                <Text style={styles.tableHeading}>{`Service By`}</Text>
              </View>
            )}
          </View>
          <View style={styles.borderBottomCommon} />
          <View style={styles.marginTop10}>
            {dtl_data.length > 0
              ? dtl_data.map((item, index) => {
                  return (
                    <View style={styles.tableBody} key={index}>
                      {this.handleChangeCheckStatus(bodyList, "Table Sno") && (
                        <Text style={styles.tableWidth}>{index + 1}</Text>
                      )}
                      {this.handleChangeCheckStatus(bodyList, "Table Desc") && (
                        <Text style={styles.width20}>{item.dt_itemdesc}</Text>
                      )}
                      {this.handleChangeCheckStatus(bodyList, "Table Qty") && (
                        <Text style={styles.tableWidth}>{item.dt_qty}</Text>
                      )}
                      {this.handleChangeCheckStatus(bodyList, "Table U/P") && (
                        <Text style={styles.tableWidth}>{item.dt_price}</Text>
                      )}
                      {this.handleChangeCheckStatus(bodyList, "Table Disc") && (
                        <Text style={styles.tableWidth}>{item.discount}</Text>
                      )}
                      {this.handleChangeCheckStatus(bodyList, "N/P") && (
                        <Text style={styles.tableWidth}>
                          {item.dt_transacamt}
                        </Text>
                      )}
                      {this.handleChangeCheckStatus(bodyList, "Table Paid") && (
                        <Text style={styles.tableWidth}>{item.dt_deposit}</Text>
                      )}

                      {this.handleChangeCheckStatus(bodyList, "Sold By") && (
                        <Text style={styles.tableWidth}>
                          {item.sales_staff}
                        </Text>
                      )}
                      {this.handleChangeCheckStatus(bodyList, "Service By") && (
                        <Text style={styles.tableWidth}>{item.work_staff}</Text>
                      )}
                    </View>
                  );
                })
              : ""}
          </View>

          <View style={styles.borderBottomCommon} />
          <View style={styles.tableHeader}>
            {this.handleChangeCheckStatus(bodyList, "Table Sno") && (
              <Text style={styles.tableWidth}></Text>
            )}
            {this.handleChangeCheckStatus(bodyList, "Table Desc") && (
              <Text style={styles.width20}></Text>
            )}
            {this.handleChangeCheckStatus(bodyList, "Table Qty") && (
              <Text style={[styles.tableWidth, styles.fontWeightBold]}>
                {sub_data.tot_qty}
              </Text>
            )}
            {this.handleChangeCheckStatus(bodyList, "Table U/P") && (
              <Text style={[styles.tableWidth, styles.fontWeightBold]}>
                {sub_data.tot_price}
              </Text>
            )}
            {this.handleChangeCheckStatus(bodyList, "Table Disc") && (
              <Text style={[styles.tableWidth, styles.fontWeightBold]}>
                {sub_data.tot_disc}
              </Text>
            )}
            {this.handleChangeCheckStatus(bodyList, "Table N/P") && (
              <Text style={[styles.tableWidth, styles.fontWeightBold]}>
                {sub_data.tot_net}
              </Text>
            )}
            {this.handleChangeCheckStatus(bodyList, "Table Paid") && (
              <Text style={[styles.tableWidth, styles.fontWeightBold]}>
                {sub_data.tot_paid}
              </Text>
            )}

            {this.handleChangeCheckStatus(bodyList, "Table Sold By") && (
              <Text style={styles.tableWidth}></Text>
            )}
            {this.handleChangeCheckStatus(bodyList, "Table Service By") && (
              <Text style={styles.tableWidth}></Text>
            )}
          </View>
          <View style={styles.borderBottomCommon} />

          <View style={styles.subTableContainer}>
            <View style={styles.width40}>
              <View style={[styles.subTotalParent, styles.subTotalBorder]}>
                <View style={styles.width40}>
                  <Text style={[styles.subTotalFont, styles.tableHeading]}>
                    No
                  </Text>
                </View>
                <View style={styles.width30}>
                  <Text style={[styles.subTotalFont, styles.tableHeading]}>
                    Type
                  </Text>
                </View>

                <View style={styles.width30}>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.texalignRight,
                      styles.tableHeading,
                    ]}
                  >
                    Amount
                  </Text>
                </View>
              </View>
              {taud_data.length > 0
                ? taud_data.map((item, index) => {
                    return (
                      <View
                        key={index}
                        style={[
                          styles.subTotalParent,
                          styles.marginVerticalTop2,
                        ]}
                      >
                        <View style={styles.width40}>
                          <Text style={styles.subTotalFont}>
                            {item.pay_rem1}
                          </Text>
                        </View>
                        <View style={styles.width30}>
                          <Text style={styles.subTotalFont}>
                            {item.pay_type_name}
                          </Text>
                        </View>

                        <View style={styles.width30}>
                          <Text
                            style={[styles.subTotalFont, styles.texalignRight]}
                          >
                            $ {item.pay_amt}
                          </Text>
                        </View>
                      </View>
                    );
                  })
                : ""}
              <View style={[styles.subTotalParent, styles.subTotalBorderTop]}>
                <View style={styles.width40}>
                  <Text style={styles.subTotalFont}>{taud_sub.gst_label}</Text>
                </View>
                <View style={styles.width30}>
                  <Text style={[styles.subTotalFont, styles.tableHeading]}>
                    Total
                  </Text>
                </View>

                <View style={styles.width30}>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.texalignRight,
                      styles.tableHeading,
                    ]}
                  >
                    {taud_sub.total}
                  </Text>
                </View>
              </View>
            </View>
            <View style={styles.width30} />

            <View style={styles.width30}>
              {this.handleChangeCheckStatus(bodyList, "Sub Total") && (
                <View style={styles.listContainer}>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                      styles.tableHeading,
                    ]}
                  >
                    {this.handleCheckNameLabel(bodyList, "Sub Total")}
                  </Text>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                    ]}
                  >
                    {sub_data.sub_total}
                  </Text>
                </View>
              )}

              {this.handleChangeCheckStatus(bodyList, "GST") && (
                <View style={styles.listContainer}>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                      styles.tableHeading,
                    ]}
                  >
                    {this.handleCheckNameLabel(bodyList, "GST")}
                  </Text>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                    ]}
                  >
                    {taud_sub.gst}
                  </Text>
                </View>
              )}
              {this.handleChangeCheckStatus(bodyList, "SST") && (
                <View style={styles.listContainer}>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                      styles.tableHeading,
                    ]}
                  >
                    SST :
                  </Text>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                    ]}
                  >
                    {taud_sub.gst}
                  </Text>
                </View>
              )}

              {this.handleChangeCheckStatus(bodyList, "Rounding") && (
                <View style={styles.listContainer}>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                      styles.tableHeading,
                    ]}
                  >
                    Rounding :
                  </Text>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                    ]}
                  >
                    {taud_sub.rounding}
                  </Text>
                </View>
              )}

              {this.handleChangeCheckStatus(bodyList, "Grand Total") && (
                <View style={styles.listContainer}>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                      styles.tableHeading,
                    ]}
                  >
                    Grand Total :
                  </Text>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                    ]}
                  >
                    {taud_sub.grand_tot}
                  </Text>
                </View>
              )}

              {this.handleChangeCheckStatus(bodyList, "Deposit") && (
                <View style={styles.listContainer}>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                      styles.tableHeading,
                    ]}
                  >
                    Deposit :
                  </Text>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                    ]}
                  >
                    {sub_data.tot_paid}
                  </Text>
                </View>
              )}

              {this.handleChangeCheckStatus(bodyList, "Outstanding") && (
                <View style={styles.listContainer}>
                  <Text
                    style={[
                      styles.subTotalFont,
                      styles.width50,
                      styles.texalignRight,
                      styles.tableHeading,
                    ]}
                  >
                    Outstanding :
                  </Text>
                  <Text
                    style={[
                      styles.fontSize9,
                      styles.width50,
                      styles.texalignRight,
                    ]}
                  >
                    {sub_data.outstanding}
                  </Text>
                </View>
              )}
            </View>
          </View>

          {showprepaid && prepaidlst && prepaidlst.length > 0 && (
            <View>
              <View style={[styles.prepaidContainer, styles.border1px]}>
                <View style={styles.width60}>
                  <Text style={styles.titlecontainer}>Program Desc </Text>
                </View>
                <View style={[styles.width40, styles.borderLeft1px]}>
                  <Text style={styles.titlecontainer}>Balance</Text>
                </View>
              </View>

              {prepaidlst.map((item, id) => {
                return (
                  <View
                    key={id}
                    style={[
                      styles.prepaidContainer,
                      styles.marginVertical4,
                      styles.borderTopHide,
                    ]}
                  >
                    <View style={styles.width60}>
                      <Text style={styles.titlecontainer}>{item.pp_desc} </Text>
                    </View>
                    <View style={styles.width40}>
                      <Text style={styles.titlecontainer}>{item.remain}</Text>
                    </View>
                  </View>
                );
              })}
            </View>
          )}
          {treatmentbal && treatment && treatment.length > 0 && (
            <View>
              <View style={[styles.prepaidContainer, styles.border1px]}>
                <View style={styles.width60}>
                  <Text style={styles.titlecontainer}>Course </Text>
                </View>
                <View style={[styles.width40, styles.borderLeft1px]}>
                  <Text style={styles.titlecontainer}>Total</Text>
                </View>
              </View>

              {treatment.map((item, index) => {
                return (
                  <View
                    style={[
                      styles.prepaidContainer,
                      styles.marginVertical4,
                      styles.borderTopHide,
                    ]}
                    key={index}
                  >
                    <View style={styles.width60}>
                      <Text style={styles.titlecontainer}>{item?.course}</Text>
                    </View>
                    <View style={styles.width60}>
                      {item?.total && (
                        <Text style={styles.titlecontainer}>
                          {" "}
                          {item?.total}
                        </Text>
                      )}
                    </View>
                  </View>
                );
              })}
            </View>
          )}

          <View style={styles.termsConditonContainer}>
            <View style={styles.width75}>
              {this.handleChangeCheckStatus(footerList, "Remarks") && (
                <View style={styles.listContainer}>
                  <Text style={[styles.subTotalFont]}>Remark :</Text>
                  <Text style={[styles.termsCondtionTitle]}>
                    {remark || ""}
                  </Text>
                </View>
              )}
              {this.handleChangeCheckStatus(footerList, "Footer List") && (
                <View>
                  <Text
                    style={[
                      styles.termsCondtionTitle,
                      styles.width100,
                      styles.marginVerticalTop2,
                    ]}
                  >
                    {footer1 || ""}
                  </Text>
                  <Text
                    style={[
                      styles.termsCondtionTitle,
                      styles.marginVerticalTop2,
                      styles.width100,
                    ]}
                  >
                    {footer2 || ""}
                  </Text>
                  <Text
                    style={[
                      styles.termsCondtionTitle,
                      styles.marginVerticalTop2,
                      styles.width100,
                    ]}
                  >
                    {footer3 || ""}
                  </Text>
                  <Text
                    style={[
                      styles.termsCondtionTitle,
                      styles.marginVerticalTop2,
                      styles.width100,
                    ]}
                  >
                    {footer4 || ""}
                  </Text>
                </View>
              )}

              {this.handleChangeCheckStatus(footerList, "Terms & Condition") &&
                NewLineText(termsText)}
            </View>
            {this.handleChangeCheckStatus(footerList, "Signature") && (
              <View style={[styles.width25, styles.customerSignatureContainer]}>
                <Image
                  style={styles.customerSignWidth}
                  src={customerSingature ? customerSingature : blankImage}
                />

                <Text
                  style={[
                    styles.subTotalFont,
                    styles.subTotalBorderTop,
                    styles.paddingTop5,
                  ]}
                >
                  {" "}
                  Customer Signature
                </Text>
              </View>
            )}
          </View>
        </Page>
      </Document>
    );
  }
}
export default PrintPreview;
